// extracted by mini-css-extract-plugin
module.exports = {"section":"Paragraph2_section__jzIsr","textContent":"Paragraph2_textContent__TI0kz","image":"Paragraph2_image__0Nlib"};